import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const squareup = defineConnector({
  identifier: "squareup",
  name: "Square",
  tagLine: "Payments and commerce platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://connect\\.squareup\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Squareup app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Square access token docs](https://developer.squareup.com/docs/build-basics/access-tokens) and create an application in the Square Developer Console. Copy the client ID and client secret from the app credentials page.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/squareup/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Squareup account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Squareup account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://connect.squareup.com/oauth2/authorize",
    tokenEndpoint: () => "https://connect.squareup.com/oauth2/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://connect.squareup.com/",
  },
});
